import type { CSSProperties } from 'react';

interface SelectProps {
  options: Array<{ label: string; value: string }>;
  selected?: string;
  placeholder?: string;
  className?: string;
  style?: CSSProperties;
}

export function SelectView({ options, selected, placeholder, className, style }: SelectProps) {
  return (
    <select
      value={selected ?? ''}
      disabled
      className={`rounded-md border border-input bg-card px-3 py-1.5 text-sm text-foreground${className ? ` ${className}` : ''}`}
      style={style}
    >
      {placeholder && <option value="">{placeholder}</option>}
      {options.map((opt) => (
        <option key={opt.value} value={opt.value}>
          {opt.label}
        </option>
      ))}
    </select>
  );
}
